import { useUDData } from '@udemy/ud-data';
import { showPlansAndPricingDropdownInMarketplaceHeader, showPlansAndPricingFrontendsNavInMarketplaceHeader } from '../external/header-experiment-features';
import { useHeaderExperimentFeatures } from './use-header-experiment-features';
import { useHeaderStore } from './use-header-store';
export const usePlansAndPricing = () => {
  const headerExperimentFeatures = useHeaderExperimentFeatures();
  const headerStore = useHeaderStore();
  const udData = useUDData();
  const showPlansAndPricingDropdown = showPlansAndPricingDropdownInMarketplaceHeader({
    headerExperimentFeatures,
    headerStore
  });
  const showPlansAndPricingFrontendsNav = showPlansAndPricingFrontendsNavInMarketplaceHeader({
    headerExperimentFeatures,
    headerStore
  });
  const isFeatureEnabled = showPlansAndPricingDropdown || showPlansAndPricingFrontendsNav;
  const isLoggedOut = !headerStore.userSpecificContext.isLoggedIn;
  const isPersonalPlanSubscriber = headerStore.isPersonalPlanSubscriber;
  const hasOrganization = udData.me.is_authenticated && !!udData.me.organization;
  const isMXUser = !isPersonalPlanSubscriber && !hasOrganization;
  const shouldShowBasedOnUserType = isLoggedOut || isMXUser;
  const showPlansAndPricingFeature = isFeatureEnabled && shouldShowBasedOnUserType;
  return {
    plansAndPricingUrl: headerStore.urls.PLANS_AND_PRICING,
    showPlansAndPricingDropdown,
    showPlansAndPricingFeature,
    showPlansAndPricingFrontendsNav
  };
};
//# sourceMappingURL=use-plans-and-pricing.js.map